export const updateAdyenMopResultSelector = state => state.configuration.adyen.updateAdyenMopResult;
